<template>
  <div class="price-package">
    <img class="price-package-bg" src="@/assets/price/背景.png" />
    <div class="price-package-label warp">
      <h2 class="price-package-label-title">
        超低价限时抢购，开启AI营销时代，零风险无忧起步！
      </h2>
      <div class="price-package-label-desc">
        <div>
          <strong>外贸极客</strong
          >，一站式智能量化营销服务（SCRM+AI），利用AI技术帮助外贸B2B出口企业轻松拓展全球市场，高效获客和精准管理，极大降低运营成本。
        </div>
      </div>
    </div>
    <div class="price-package-img warp">
      <div class="price-package-item">
        <div class="price-package-item-top"></div>
        <div class="price-package-item-content">
          <div class="price-package-item-content-title">
            <div class="price-package-item-content-title-value">专业版</div>
            <div class="price-package-item-content-title-tag">人工辅助实施</div>
          </div>
          <div class="price-package-item-content-hashtag">
            <div>
              <div class="hashtag-item">智能助手</div>
              <div class="hashtag-item">营销内容生成</div>
              <div class="hashtag-item">独立站和站群、网站SEO</div>
              <div class="hashtag-item">社媒运营(Facebook、LInkedin）</div>
              <div class="hashtag-item">
                海关数据+企业查询+邮件查询+地图获客<span
                  class="hashtag-item-span2"
                  >（需单独购买）</span
                >
              </div>
            </div>
            <div>
              <div class="hashtag-item">
                邮件营销<span class="hashtag-item-span">（需单独购买）</span>
              </div>

              <div class="hashtag-item">
                客户管理<span class="hashtag-item-span1">（限时赠送）</span>
              </div>

              <div class="hashtag-item">AI产品外贸专家顾问</div>

              <div class="hashtag-item">人工辅助实施服务</div>
            </div>
          </div>
          <div class="price-package-item-btn" @click="showModal">预约演示</div>
          <div class="price-package-item-label">
            <div class="price-package-item-label-item" v-for="item in dataList">
              <span class="iconfont icon-duihao"></span>
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="price-package-item price-package-item-right">
        <div class="price-package-item-top"></div>
        <img class="price-package-item-icon" src="@/assets/price/角标.png" />
        <div class="price-package-item-content">
          <div class="price-package-item-content-title">
            <div class="price-package-item-content-title-value">铂金版</div>
            <div class="price-package-item-content-title-tag">智能推广支持</div>
          </div>
          <div class="price-package-item-content-subtitle">专业版所有功能</div>
          <div class="price-package-item-content-hashtag">
            <div>
              <div class="hashtag-item">
                <span class="iconfont">+</span>AI推广功能服务
              </div>
              <div class="hashtag-item">
                <span class="iconfont">+</span>AI智能客服功能服务<span
                  class="hashtag-item-span1"
                >
                  （限时赠送）</span
                >
              </div>
            </div>
            <div class="hashtag-item">
              <span class="iconfont">+</span>商机监控<span
                class="hashtag-item-span1"
              >
                （限时赠送）</span
              >
            </div>
          </div>
          <div class="price-package-item-btn" @click="showModal">预约演示</div>
          <div class="price-package-item-label">
            <div
              class="price-package-item-label-item"
              v-for="(item, index) in dataList1"
              :class="{ activeItem: index > 7 }"
            >
              <span class="iconfont icon-duihao"></span>
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import img1 from "@/assets/home/推广引流.png";
import img2 from "@/assets/home/快速获客.png";
import img3 from "@/assets/home/高效成交.png";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";

export default {
  components: {
    inquiryModalVue,
  },
  data() {
    return {
      tabValue: 0,
      img1: img1,
      img2: img2,
      img3: img3,
      visible: false,
      dataList: [
        "快速树立优质品牌形象",
        "AI提升团队营销效率",
        "多渠道营销整合 客源翻倍",
        "每年节省15-30万营销成本",
        "自动生成高质量营销内容",
        "智能建站 高效SEO优化",
        "AI营销工具 性价比超高",
        "专业配置和建站服务",
      ],
      dataList1: [
        "快速树立优质品牌形象",
        "AI提升团队营销效率",
        "多渠道营销整合 客源翻倍",
        "每年节省15-30万营销成本",
        "自动生成高质量营销内容",
        "智能建站 高效SEO优化",
        "AI营销工具 性价比超高",
        "专业配置和建站服务",
        "AI自动化推广 省时省力",
        "24*7 AI智能客服，高满意度",
      ],
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.price-package {
    padding-top: 96px;
    position: relative;
    .warp {
      width: 1200px !important;
      }
    .price-package-bg {
      width: 100%;
      position: absolute;
      top: 0px;
      }
        .price-package-label {
          position: relative;
      z-index: 9;
      text-align: center;
      .price-package-label-title {
        font-family: AlibabaPuHuiTiM;
        font-weight: 500;
font-size: 44px;
color: #262945;
line-height: 52px;
        }
        .price-package-label-desc {
          margin: 20px 0;
          font-family: "Alibaba-PuHuiTi-R";
font-size: 20px;
color: #262945;
line-height: 40px;
div {
  width: 710px;
  text-align: center;
  margin: 0 auto;
  }
          }
          }
    .price-package-img {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 9;
      column-gap: 40px;
      .price-package-item {
        background: #FFFFFF;
border-radius: 15px;
width: 49%;
height: 873px;
.price-package-item-top {
  height: 18px;
background: linear-gradient( 89deg, #BE9D87 0%, #E9D9C8 100%);
border-radius: 15px 15px 0 0;
  }
    .price-package-item-content {
      padding: 16px 32px;
      .price-package-item-content-title {
        display: flex;
        column-gap: 10px;
        align-items: center;
        .price-package-item-content-title-value {
          font-weight: 500;
font-size: 34px;
color: #111111;
          }
            .price-package-item-content-title-tag {
              width: 97px;
height: 26px;
border-radius: 4px;
font-size: 13px;
color: #B38D74;
text-align: center;
line-height: 26px;
border: 1px solid #B38D74;
              }
        }
          .price-package-item-content-hashtag {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            .hashtag-item {
              // width: 49%;
              font-weight: 500;
font-size: 15px;
color: #333333;
line-height: 32px;
display: flex;
align-items: center;
.hashtag-item-span {
  color: #999999;
  font-size: 12px;
  }
    .iconfont {
      color: #fff;
      width: 16px;
height: 16px;
background: #1BB84F;
border-radius: 50%;
display: inline-block;
margin-right: 10px;
font-size: 16px;
line-height: 13px;
text-align: center;
      }
  .hashtag-item-span1 {
  font-size: 15px;
  background-image: linear-gradient( 89deg, #BE9D87 0%, #E9D9C8 100%);
   background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  }
  .hashtag-item-span2 {
  color: #666666;
  font-size: 15px;
  }
              }
            }
      }
        .price-package-item-btn {
          height: 45px;
background: linear-gradient( 270deg, #EADBCB 0%, #BE9D87 100%);
border-radius: 8px;
line-height: 45px;
text-align: center;
font-weight: 500;
font-size: 18px;
color: #50341C;
cursor: pointer;
margin: 23px 0 20px 0;
          }
            .price-package-item-label {
              display: flex;
              row-gap: 14px;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .activeItem {
                color: #000000 !important;
                }
              .price-package-item-label-item {
                display: flex;
                column-gap: 16px;
                font-size: 18px;
color: rgba(51, 51, 51, 0.8);
line-height: 38px;
                .iconfont {
                  color:#1BB84F;
                  font-size: 16px;
                  }
                }
              }
        }
          .price-package-item-right {
            position: relative;
            .price-package-item-top {
      background: linear-gradient( 83deg, #393028 0%, #E8CCAD 100%);
      }
        .price-package-item-icon {
          position: absolute;
          right: -18px;
          top: -18px;
          }
      .price-package-item-content-title-tag {
        color: #61574C !important;
        border-color: #61574C !important;
        }
          .price-package-item-content-subtitle {
            height: 72px;
background: rgba(230,214,197,0.1);
border-radius: 10px;
text-align: center;
font-weight: 500;
font-size: 16px;
color: #000000;
line-height: 72px;
margin: 20px 0 10px 0;
            }
              .price-package-item-btn {
                background: linear-gradient( 90deg, #221D17 0%, #61574C 100%) !important;
                color: #F5DBC8 !important;
                }
            }
      }
    }
</style>
